// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cases_root__hikZ5 {
  width: 100%;
}

.Cases_hide_case_list__\\+Ncru {
  display: none;
}

.Cases_case_list_container__LUy\\+i {
  position: fixed;
  left: 210px;
  top: 110px;
  width: 290px;
  background-color: var(--color-bg-caselist);
  overflow: scroll;
  padding: 10px;
  padding-top: 60px;
  overflow-x: hidden;
  height: calc(100vh - 103px);
}

.Cases_case_details_container__O0s\\+1 {
  overflow: scroll;
  margin-left: 310px;
  background-color: var(--color-bg-content);
  overflow: scroll;
  height: calc(100vh - 107px);
  padding-bottom: 38px;
}

.Cases_search_case_container__cICoC {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.Cases_sort_icon_container__D3LsP {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  cursor: pointer;
}

.Cases_add_case_container__a1VFZ {
  z-index: 2;
  position: fixed;
  left: 210px;
  top: 91px;
  width: 310px;
  background-color: var(--color-bg-caselist);
}

.Cases_cases_top_container__YZSYR {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.Cases_case_report_icon__WQIWS {
  margin-left: auto;
  cursor: pointer;
  align-items: center;
  border: 1px solid;
  border-radius: 12px;
  padding: 2px 6px;
  margin-right: 6px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.Cases_case_report_icon__WQIWS:hover {
  background-color: var(--color-caselist-caselist, #e3f2fd);
  border: 1px solid var(--color-bg-caselist, #e3f2fd);
}

.Cases_filter_container__9POQW {
  display: inline-flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}

.Cases_filter_counter__-TOxk {
  margin-right: 20px;
}

.Cases_btn_add_case__gv10h {
  flex: 2 1;
  width: 160px !important;
  font-weight: 600 !important;
  color: var(--color-theme-10) !important;
  height: 40px;
  line-height: 0px !important;
  border-radius: 5px !important;
  margin: 10px !important;
  margin-bottom: 0px !important;
}

.Cases_btn_add_case__gv10h:hover {
  color: var(--color-theme-blue) !important;
  background-color: var(--color-theme-lightblue) !important;
}

.Cases_plus_sign__\\+cwsr {
  margin-right: 10px;
  font-size: 20px;
}

.Cases_case_row_unfolded__DyjTS {
  overflow: hidden;
  transition: max-height 0.3s ease-in;
  max-height: 90px;
}

.Cases_case_row_folded__Cktqa {
  overflow: hidden;
  max-height: 0px;
  transition: max-height 0.3s ease-out;
}

.Cases_filterIconActive__eXXmd {
  position: relative !important;
  height: 30px !important;
  margin-left: 14px !important;
  color: rgb(75, 75, 75) !important;
  cursor: pointer !important;
  min-width: 20px !important;
}

.Cases_filterMenuPaper__1VuzR {
  width: 218px;
  padding: 6px 6px;
  position: absolute;
  text-align: left;
  z-index: 2;
}

.Cases_filterMenuRow__NLp-M {
  padding: 12px 2px;
  cursor: pointer;
}

.Cases_filterMenuRow__NLp-M:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.Cases_add_case_button__wlHWs {
  margin: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}

.Cases_add_case_button__wlHWs > button {
  background-color: white;
}

/* Search dropdown and tag styles */
.Cases_search_container__cI-Kn {
  position: relative;
  width: 100%;
}

.Cases_search_tag__Ys3ZM {
  display: inline-flex;
  align-items: center;
  background-color: var(--color-theme-lightblue, #e3f2fd);
  color: var(--color-theme-blue, #1976d2);
  border: 1px solid var(--color-theme-blue, #1976d2);
  border-radius: 12px;
  padding: 2px 6px;
  margin-right: 6px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.Cases_search_tag__Ys3ZM span {
  margin-right: 4px;
}

.Cases_remove_tag_btn__ZQp8r {
  background: none;
  border: none;
  color: var(--color-theme-blue, #1976d2);
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  padding: 0;
  margin-left: 3px;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.Cases_remove_tag_btn__ZQp8r:hover {
  background-color: rgba(25, 118, 210, 0.1);
}

.Cases_bottom_cases_options__WfYUu {
  display: flex;
  padding: 5px;
  align-items: center;
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Cases/Cases.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAGlB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,2BAA2B;EAC3B,uCAAuC;EACvC,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uDAAuD;EACvD,uCAAuC;EACvC,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".root {\n  width: 100%;\n}\n\n.hide_case_list {\n  display: none;\n}\n\n.case_list_container {\n  position: fixed;\n  left: 210px;\n  top: 110px;\n  width: 290px;\n  background-color: var(--color-bg-caselist);\n  overflow: scroll;\n  padding: 10px;\n  padding-top: 60px;\n  overflow-x: hidden;\n  height: -webkit-calc(100vh - 103px);\n  height: -moz-calc(100vh - 103px);\n  height: calc(100vh - 103px);\n}\n\n.case_details_container {\n  overflow: scroll;\n  margin-left: 310px;\n  background-color: var(--color-bg-content);\n  overflow: scroll;\n  height: calc(100vh - 107px);\n  padding-bottom: 38px;\n}\n\n.search_case_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.sort_icon_container {\n  width: 10%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.add_case_container {\n  z-index: 2;\n  position: fixed;\n  left: 210px;\n  top: 91px;\n  width: 310px;\n  background-color: var(--color-bg-caselist);\n}\n\n.cases_top_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 10px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.case_report_icon {\n  margin-left: auto;\n  cursor: pointer;\n  align-items: center;\n  border: 1px solid;\n  border-radius: 12px;\n  padding: 2px 6px;\n  margin-right: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.case_report_icon:hover {\n  background-color: var(--color-caselist-caselist, #e3f2fd);\n  border: 1px solid var(--color-bg-caselist, #e3f2fd);\n}\n\n.filter_container {\n  display: inline-flex;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.filter_counter {\n  margin-right: 20px;\n}\n\n.btn_add_case {\n  flex: 2;\n  width: 160px !important;\n  font-weight: 600 !important;\n  color: var(--color-theme-10) !important;\n  height: 40px;\n  line-height: 0px !important;\n  border-radius: 5px !important;\n  margin: 10px !important;\n  margin-bottom: 0px !important;\n}\n\n.btn_add_case:hover {\n  color: var(--color-theme-blue) !important;\n  background-color: var(--color-theme-lightblue) !important;\n}\n\n.plus_sign {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.case_row_unfolded {\n  overflow: hidden;\n  transition: max-height 0.3s ease-in;\n  max-height: 90px;\n}\n\n.case_row_folded {\n  overflow: hidden;\n  max-height: 0px;\n  transition: max-height 0.3s ease-out;\n}\n\n.filterIconActive {\n  position: relative !important;\n  height: 30px !important;\n  margin-left: 14px !important;\n  color: rgb(75, 75, 75) !important;\n  cursor: pointer !important;\n  min-width: 20px !important;\n}\n\n.filterMenuPaper {\n  width: 218px;\n  padding: 6px 6px;\n  position: absolute;\n  text-align: left;\n  z-index: 2;\n}\n\n.filterMenuRow {\n  padding: 12px 2px;\n  cursor: pointer;\n}\n\n.filterMenuRow:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.add_case_button {\n  margin: auto;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.add_case_button > button {\n  background-color: white;\n}\n\n/* Search dropdown and tag styles */\n.search_container {\n  position: relative;\n  width: 100%;\n}\n\n.search_tag {\n  display: inline-flex;\n  align-items: center;\n  background-color: var(--color-theme-lightblue, #e3f2fd);\n  color: var(--color-theme-blue, #1976d2);\n  border: 1px solid var(--color-theme-blue, #1976d2);\n  border-radius: 12px;\n  padding: 2px 6px;\n  margin-right: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.search_tag span {\n  margin-right: 4px;\n}\n\n.remove_tag_btn {\n  background: none;\n  border: none;\n  color: var(--color-theme-blue, #1976d2);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  padding: 0;\n  margin-left: 3px;\n  width: 14px;\n  height: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.remove_tag_btn:hover {\n  background-color: rgba(25, 118, 210, 0.1);\n}\n\n.bottom_cases_options {\n  display: flex;\n  padding: 5px;\n  align-items: center;\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Cases_root__hikZ5`,
	"hide_case_list": `Cases_hide_case_list__+Ncru`,
	"case_list_container": `Cases_case_list_container__LUy+i`,
	"case_details_container": `Cases_case_details_container__O0s+1`,
	"search_case_container": `Cases_search_case_container__cICoC`,
	"sort_icon_container": `Cases_sort_icon_container__D3LsP`,
	"add_case_container": `Cases_add_case_container__a1VFZ`,
	"cases_top_container": `Cases_cases_top_container__YZSYR`,
	"case_report_icon": `Cases_case_report_icon__WQIWS`,
	"filter_container": `Cases_filter_container__9POQW`,
	"filter_counter": `Cases_filter_counter__-TOxk`,
	"btn_add_case": `Cases_btn_add_case__gv10h`,
	"plus_sign": `Cases_plus_sign__+cwsr`,
	"case_row_unfolded": `Cases_case_row_unfolded__DyjTS`,
	"case_row_folded": `Cases_case_row_folded__Cktqa`,
	"filterIconActive": `Cases_filterIconActive__eXXmd`,
	"filterMenuPaper": `Cases_filterMenuPaper__1VuzR`,
	"filterMenuRow": `Cases_filterMenuRow__NLp-M`,
	"add_case_button": `Cases_add_case_button__wlHWs`,
	"search_container": `Cases_search_container__cI-Kn`,
	"search_tag": `Cases_search_tag__Ys3ZM`,
	"remove_tag_btn": `Cases_remove_tag_btn__ZQp8r`,
	"bottom_cases_options": `Cases_bottom_cases_options__WfYUu`
};
export default ___CSS_LOADER_EXPORT___;
